import React, { ReactElement } from 'react';

export default function NotFound(): ReactElement {

    return <h1>Not found!</h1>;
}
